import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HardDriveUpload } from "lucide-react";
import { toast } from "sonner";

export function LegacyMigrationCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/attachment-migration/status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/attachment-migration/run"); toast.success(`Moved ${data.moved} file${data.moved === 1 ? "" : "s"} to object storage${data.failed ? `, ${data.failed} failed` : ""}`); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!s) return null;
  return (
    <Card className="p-4 sm:p-5" data-testid="legacy-migration-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-semibold font-display flex items-center gap-2"><HardDriveUpload className="w-4 h-4 text-primary" /> Document storage</h3>
          <p className="text-xs text-muted-foreground mt-0.5" data-testid="legacy-migration-status">{s.total} documents on file · {s.migrated} migrated · <span className={s.legacy ? "text-amber-600 font-medium" : "text-emerald-600 font-medium"}>{s.legacy ? `${s.legacy} still in legacy database storage` : "all in object storage"}</span></p>
        </div>
        {s.legacy > 0 && <Button size="sm" variant="outline" data-testid="legacy-migrate-btn" disabled={busy} onClick={run}>{busy ? "Migrating…" : "Migrate now"}</Button>}
      </div>
    </Card>
  );
}
